import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "sound-source-component" }
const _hoisted_2 = { id: "sound-source-controls" }
const _hoisted_3 = { class: "gain" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EffectSelect = _resolveComponent("EffectSelect")!
  const _component_RangeEffectControl = _resolveComponent("RangeEffectControl")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("h2", null, "Noise", -1)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleRemove && _ctx.handleRemove(...args)), ["prevent"]))
      }, "Remove"),
      _withDirectives(_createElementVNode("button", {
        ref: "muteBtn",
        onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleMute && _ctx.handleMute(...args)), ["prevent"]))
      }, " Mute ", 512), [
        [_vShow, !_ctx.activeNoiseSource.isMuted]
      ]),
      _withDirectives(_createElementVNode("button", {
        ref: "unmuteBtn",
        onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleUnMute && _ctx.handleUnMute(...args)), ["prevent"]))
      }, " Unmute ", 512), [
        [_vShow, _ctx.activeNoiseSource.isMuted]
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("button", null, "Duplicate", -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[5] || (_cache[5] = _createElementVNode("label", { for: "gain" }, "Gain", -1)),
      _createElementVNode("input", {
        name: "gain",
        ref: "gainCtrl",
        type: "range",
        min: "0",
        max: "0.5",
        step: "any",
        value: "0.1",
        onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleGainChange && _ctx.handleGainChange(...args)))
      }, null, 544)
    ]),
    _createVNode(_component_EffectSelect, {
      availableEffects: _ctx.availableEffects,
      onSelectEffect: _ctx.handleEffectSelected
    }, null, 8, ["availableEffects", "onSelectEffect"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeEffects, (effect, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "effect",
        key: effect.name
      }, [
        (effect.controlType === 'range')
          ? (_openBlock(), _createBlock(_component_RangeEffectControl, {
              key: i,
              effect: effect,
              audioContext: _ctx.audioContext,
              effectNode: _ctx.getEffectNode(effect.name),
              onEffectRemoved: _ctx.handleRemoveEffect
            }, null, 8, ["effect", "audioContext", "effectNode", "onEffectRemoved"]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}